const AnswerButton = (props) => {
  return (
    <>
      <div
        onClick={() => props.checkAnswer(props.correct)}
        dangerouslySetInnerHTML={{ __html: props.text }}
        className={`col-12 col-lg-6 btn btn-lg p-3 p-md-5  rounded-0 border border-white  ${
          props.answered && props.correct ? "btn-success" : "btn-primary"
        }`}
      ></div>
      {props.id === 1 && <div className="w-100"></div>}
    </>
  )
}

export default AnswerButton
